import styles from "@/styles/login.module.scss"
import Head from "next/head"
import LoginLayout from "@/components/LoginLayout"
import LoginForm from "@/components/login/LoginForm"
import RegisterForm from "@/components/login/RegisterForm"
import { useRouter } from "next/router";
import { useState, useEffect } from "react"
import { GoogleOAuthProvider } from '@react-oauth/google';

export default function PageLogin() {
  const router = useRouter();

  const [isLogin, setIsLogin] = useState(true)
  const [redirectUrl, setRedirectUrl] = useState('')

  // 切换登录/注册
  const handleSwitchType = async (type: string) => {
    if (type == 'login') {
      setIsLogin(true)
    } else if (type == 'register') {
      setIsLogin(false)
    }
  }

  // 登录、注册成功，返回前页面
  const pageReturn = () => {
    if (redirectUrl) {
      router.replace(redirectUrl);
    } else {
      router.replace('/');
    }
  }

  useEffect(() => {
    const params = new URLSearchParams(router.asPath.split('?')[1]);
    const redirect = params.get('redirect');
    const type = params.get('type');

    // 存贮重定向地址
    if (redirect) {
      setRedirectUrl(redirect)
    }

    // 设置展示登录/注册页面
    if (type == 'register') {
      setIsLogin(false)
    }

    // 有token就认定为已经登录，立即跳转回去
    if (localStorage.getItem('userToken')) {
      pageReturn()
    }
  }, [])

  const [clientId, setClientId] = useState('');

  useEffect(() => {
    const hostname = window.location.hostname;
    let clientId;

    if (hostname === 'www.crazysales.com.au') {
      clientId = '643230432397-9qc19dbq4uoa4tikeithrnaj85r6gmvm.apps.googleusercontent.com';
    } else {
      clientId = '643230432397-lsjfp81vnovet7l9nahi6a3u8274mnpu.apps.googleusercontent.com';
    }

    setClientId(clientId);
  }, []);

  if (!clientId) return null; // Wait for clientId to be set

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta 
          name="description" 
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <LoginLayout>
        <div className={styles['page-login']}>
          {
            isLogin
            ?
            <LoginForm 
              onSwitchType={handleSwitchType}
              onSuccessJump={pageReturn}></LoginForm>
            :
            <RegisterForm 
              onSwitchType={handleSwitchType}
              onSuccessJump={pageReturn}></RegisterForm>
          }
        </div>
      </LoginLayout>
    </GoogleOAuthProvider>
  )
}